import { cls } from "@wss/cls";
import React from "react";
import PlusIneligibleModal from "~/common/components/PlusIneligibleModal";
import usePlusModalLauncher from "~/common/PlusSubscriptionModal/hooks/usePlusModalLauncher";
import { PlusModalData } from "~/common/PlusSubscriptionModal/Models";
import { User } from "~/common/Store/connectUserAndChat";
interface PlusSignupLinkProps {
  plusModalData?: PlusModalData;
  user: User;
}
const buttonClasses = cls("flex", "justify-start", "items-center", "pt-0.5", "xxxs:px-0", "text-xs", "border-0", "shadow-[0px_1px_0px_0px_#FFFFFF]", "font-medium", "text-blue-800", "underline", "bg-transparent", "hover:text-blue-900");
const PlusSignupLink = ({
  plusModalData,
  user
}: PlusSignupLinkProps) => {
  const {
    handlePlusModalLaunch
  } = usePlusModalLauncher(plusModalData, user);
  if (user.hasWebPlus || !plusModalData) return null;
  return <>
      <button className={buttonClasses} data-testid="plus_memberPrice_cta" onClick={handlePlusModalLaunch} type="button">
        Sign up for Plus
      </button>
      <PlusIneligibleModal data-sentry-element="PlusIneligibleModal" data-sentry-source-file="PlusSignupLink.tsx" />
    </>;
};
export default PlusSignupLink;